import React from 'react';
import type { AdminFlowQuestion } from '../types';

export const PRESET_QUESTIONS: AdminFlowQuestion[] = [
  {
    id: 'imageAspectRatio', type: 'select', title: '選擇圖片比例', page: 1, required: true,
    prompt: '<圖片比例大小> ::answer:: </圖片比例大小>',
    options: [
      { value: 'A4',   label: 'A4 海報',   prompt: '符合A4紙張的長寬比' },
      { value: '1:1',  label: '1:1 方形',  prompt: '正方形的長寬比, 1:1' },
      { value: '16:9', label: '16:9 橫向', prompt: '符合16:9的長寬比 常見於橫向螢幕' },
      { value: '4:3',  label: '4:3 比例',  prompt: '符合4:3的長寬比 常見於舊版橫向畫面' },
    ],
  },
  {
    id: 'imageStyle', type: 'select', title: '選擇視覺風格', page: 1, required: true,
    prompt: '<圖片風格> ::answer:: </圖片風格>',
    options: [
      { value: 'modern',   label: '簡約科技', prompt: '現代科技、簡約風格，排版乾淨。偏冷色調' },
      { value: 'nature',   label: '自然清新', prompt: '自然、清新、不做作 簡潔親民。偏綠色調' },
      { value: 'warm',     label: '溫馨親切', prompt: '親切、溫暖、柔和 不過度用力。偏暖色調' },
      { value: 'festive',  label: '熱情活力', prompt: '熱情、活力、節慶感 鮮豔飽和。偏紅色調' },
    ],
  },
  {
    id: 'imageUpload', type: 'image', title: '上傳活動素材照片', page: 2, required: false,
    prompt: '<參考圖片> ::answer:: </參考圖片>',
  },
  {
    id: 'usePersonalPhoto', type: 'boolean', title: '套用個人形象照', page: 2, required: false,
    prompt: { true: '<使用里長個人形象照>', false: '<不使用里長個人形象照>' },
  },
  {
    id: 'textToneInImage', type: 'select', title: '圖片中文字的語氣', page: 2, required: true,
    prompt: '<圖片中文字的語氣> ::answer:: </圖片中文字的語氣>',
    options: [
      { value: 'friendly',     label: '親切溫馨', prompt: '請使用親切、溫馨、極易親近的語氣。以同理心與鄰里關懷的態度稱呼社區成員（里民）。' },
      { value: 'professional', label: '正式專業', prompt: '請使用正式、專業、清晰客觀的語氣。重點在於有效率地傳達行政資訊，適合官方或社區正式公告。' },
      { value: 'energetic',    label: '熱情活力', prompt: '請使用熱情、充滿活力且具感染力的語氣。使用鼓勵參與的字句，為在地活動營造期待感。' },
      { value: 'humorous',     label: '幽默有趣', prompt: '請使用輕鬆、機智、帶點幽默的語氣。適度加入趣味性，讓社區公告在保持核心訊息清晰的同時也具娛樂性。' },
    ],
  },
  {
    id: 'contentInImage', type: 'text', title: '圖片文字內容', page: 2, required: true,
    prompt: '<圖片中的文字內容> ::answer:: </圖片中的文字內容>',
  },
];

interface AddQuestionBarProps {
  activePage: number;
  existingIds: Set<string>;
  onAddPreset: (q: AdminFlowQuestion) => void;
  onAddBlank: (type: AdminFlowQuestion['type']) => void;
}

const AddQuestionBar: React.FC<AddQuestionBarProps> = ({ activePage, existingIds, onAddPreset, onAddBlank }) => {
  return (
    <div className="mt-4 border-t dark:border-gray-700 pt-4 space-y-2.5">
      <div>
        <p className="text-xs text-gray-400 dark:text-gray-500 mb-1.5">插入預設題目：</p>
        <div className="flex flex-wrap gap-1.5">
          {PRESET_QUESTIONS.map(p => {
            const exists = existingIds.has(p.id);
            return (
              <button
                key={p.id}
                onClick={() => onAddPreset({ ...p, page: activePage })}
                className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
                  exists
                    ? 'border-green-400 text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 cursor-default'
                    : 'border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-blue-400 hover:text-blue-600 dark:hover:text-blue-400'
                }`}
              >
                {exists ? '✓ ' : ''}{p.id}
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <p className="text-xs text-gray-400 dark:text-gray-500 mb-1.5">新增空白題目：</p>
        <div className="flex gap-1.5">
          {(['text', 'select', 'image', 'boolean'] as AdminFlowQuestion['type'][]).map(t => (
            <button key={t} onClick={() => onAddBlank(t)}
              className="text-xs px-2.5 py-1 rounded-full border border-blue-300 dark:border-blue-600 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors">
              + {t}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddQuestionBar;
